<template>
  <div>
    <v-dialog v-model="hideShow" width="1040" persistent scrollable content-class="todo-feedback-dialog" aria-label="待点评（按班级）">
      <v-card class="wa-shell tf-shell">
        <v-card-title class="wa-header">
          <span class="wa-symbol"><v-icon size="26" color="#d9363e">mdi-comment-multiple-outline</v-icon></span>
          <div class="wa-heading"><h2>待点评（按班级）</h2><p>按班级整理课堂反馈，一次完成本节课点评</p></div>
          <span class="wa-count"><strong>{{data.total}}</strong><span>节待点评</span></span>
          <v-btn icon aria-label="关闭待点评（按班级）" @click="cancel"><v-icon size="22">mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="wa-body">
          <div class="tf-toolbar">
            <div class="tf-list-heading"><h3>班级课次</h3><p>选择课次，为班级学员统一点评</p></div>

          </div>
          <v-data-table class="wa-table tf-table" :headers="data.headers" :items="data.list" :loading="data.query.loading" fixed-header disable-pagination hide-default-footer item-key="id" loading-text="正在加载，请稍候…" no-data-text="暂无待点评记录" :mobile-breakpoint="0">
            <template v-slot:item.classDate="{item}"><div class="tf-date"><time>{{item.classDate}}</time><span>{{item.weekAtName}} {{item.timeFrom}}–{{item.timeTo}}</span></div></template>
            <template v-slot:item.courseName="{item}"><span class="tf-course">{{item.courseName}}</span></template>
            <template v-slot:item.className="{item}"><span class="wa-class">{{item.className}}</span></template>
            <template v-slot:item.studentName="{item}"><span class="tf-student">{{item.studentName}}</span></template>
            <template v-slot:item.teacherName="{item}"><span class="wa-teacher"><span class="wa-avatar">{{(item.teacherName || '师').slice(0,1)}}</span><span>{{item.teacherName || '—'}}</span></span></template>
            <template v-slot:item.action="{item}"><v-btn class="wa-approve tf-action" small depressed color="#d9363e" dark @click="showRate(item)" :aria-label="'点评 '+(item.studentName || item.className)+' '+item.classDate">点评<v-icon size="16" right>mdi-chevron-right</v-icon></v-btn></template>
            <template v-slot:no-data><div class="wa-empty"><v-icon size="40" color="#a8b7c7">mdi-comment-multiple-outline</v-icon><strong>暂无待点评记录</strong><span>当前范围内没有需要处理的课堂记录</span></div></template>
          </v-data-table>
        </v-card-text>

        <v-card-actions class="wa-footer">
          <div class="wa-page-size"><span>每页</span><v-select :items="[10,20,50,100]" @change="handleSizeChanged" dense hide-details outlined v-model="data.query.size" color="#d9363e" aria-label="每页记录数量" /><span>条</span></div>
          <span class="wa-total">共 {{data.total}} 条</span>
          <v-spacer />
          <v-pagination v-if="Math.ceil(data.total/data.query.size)>0" class="wa-pagination" :length="Math.ceil(data.total/data.query.size)" @input="handlePageChanged" :total-visible="5" v-model="data.query.page" color="#d9363e" aria-label="待点评（按班级）分页" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <rateRecordClass :show="rate.show" :recordRate="rate.recordRate" @cancel="rate.show=false" @success="rateSuccess" />
  </div>
</template>

<script>
	import utils from "../config/utils"
	import rateRecordClass from "./rate_record_class.vue"
	export default {
		name:"record-wait-rate",
		components:{rateRecordClass},
		props:{
			show:{
				type:Boolean,
				default:false
			}
		},
		watch:{
			show(newVal,oldVal){
				this.hideShow = newVal;
				if (this.hideShow){
					this.getDataList();
				}
			}
		},
		data(){
			return {
				hideShow:this.show,
				shopId:"",
				data: {
					total:0,
					query:{
						loading:false,
						page:1,
						size:10
					},
					headers:[
						{
							text: '课程',
							value: 'courseName',
							sortable: false
						},
						{
							text: '班级',
							value: 'className',
							sortable: false
						},
						{
							text: '上课时间',
							value: 'classDate',
							sortable: false
						},
						{
							text: '老师',
							value: 'teacherName',
							sortable: false
						},
						{
							text: '操作',
							value: 'action',
							sortable: false
						},
					],
					list:[],
					
				},
				rate:{
					show:false,
					recordRate:null
				}
			}
		},
		mounted() {
			this.shopId = utils.getCurrentShopId();
			console.log("record-wait-rate-box mounted");
		
		},
		methods:{
			handleSizeChanged(size) {
				this.data.query.size = size;
				this.data.query.page = 1;
				this.getDataList();
			},
			handlePageChanged(page) {
				this.data.query.page = page;
				this.getDataList();
			},
			showRate(item){
				this.rate.recordRate = item;
				this.rate.show = true;
			},
			rateSuccess(){
				this.getDataList();
				this.rate.show = false;
			},
			getDataList(){
				const that = this;
		
				let url = `/edu/teacher/wait/rate/for/record/list/page/${that.data.query.page - 1}/size/${that.data.query.size}?v=1`;
				
				if (this.shopId){
					url += "&shopId="+this.shopId;
				}
							
				this.axios.get(url).then(response => {
							
					if (response.data["code"] === 200) {
						
						console.log(response.data);
						
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];
						return
					}
				})
			},
			cancel(){
				this.$emit("cancel","")
			}
		}
	}
	
</script>

<style lang="scss" scoped src="../assets/styles/todo-feedback.scss"></style>
